(function(){
  const SALE_COLOR = "#FF0000";   // Sale price hover color
  const BASE_COLOR = "#CDA44A";   // Default grey before hover
  const STYLE_ID = "hp-sale-price-styles";

  // Only run on homepage
  function isHomepage() {
    return (
      location.pathname === "/" ||
      location.pathname === "" ||
      document.body.classList.contains("template-index") ||
      (document.body.dataset && document.body.dataset.template === "index")
    );
  }
  if (!isHomepage()) return;

  const css = `
    .price, .price--highlight { 
      color: ${BASE_COLOR} !important;
      transition: color 0.4s ease-in-out; transform 0.3s ease-in-out;
      display: inline-block; /* needed for smooth scale */
    }
    .price:hover, .price--highlight:hover {
      color: ${SALE_COLOR} !important;
      transform: scale(1.05);
    }
  `;

  function stylePriceElement(pp) {
    try {
      if (!pp) return;

      if (pp.shadowRoot) {
        // Shadow DOM case
        let styleTag = pp.shadowRoot.getElementById(STYLE_ID);
        if (!styleTag) {
          styleTag = document.createElement("style");
          styleTag.id = STYLE_ID;
          styleTag.textContent = css;
          pp.shadowRoot.appendChild(styleTag);
        }
      } else {
        // Light DOM case
        let styleTag = pp.querySelector(`#${STYLE_ID}`);
        if (!styleTag) {
          styleTag = document.createElement("style");
          styleTag.id = STYLE_ID;
          styleTag.textContent = css;
          pp.appendChild(styleTag);
        }
      }
    } catch (err) {
      console.warn("Sale price styling error:", err);
    }
  }

  function applyToAllPrices() {
    document.querySelectorAll("product-price, price-component, [data-product-price]")
      .forEach(stylePriceElement);
  }

  // First run
  setTimeout(applyToAllPrices, 300);

  // Watch for dynamically added prices
  new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches("product-price, price-component, [data-product-price]")) {
          stylePriceElement(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll("product-price, price-component, [data-product-price]")
              .forEach(stylePriceElement);
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // Re-run multiple times to catch late loads
  let attempts = 0;
  const intervalId = setInterval(() => {
    attempts++;
    applyToAllPrices();
    if (attempts > 12) clearInterval(intervalId);
  }, 500);
})();
